(() => {
  const root = document.querySelector('[data-xm-language-switcher]');
  if (!root || root.dataset.smartLocalizationReady === 'true') return;
  root.dataset.smartLocalizationReady = 'true';

  const form = root.querySelector('form');
  const languageInput = root.querySelector('[data-xm-language-input]');
  const choices = Array.from(root.querySelectorAll('[data-xm-language-choice]'));
  if (!form || !languageInput || choices.length < 2) return;

  const preferenceKey = 'xm_language_preference';
  const currentLanguage = (root.dataset.currentLanguage || 'en').toLowerCase();
  const availableLanguages = choices.map((choice) => choice.value.toLowerCase());

  const localizedPath = (language) => {
    const currentPath = window.location.pathname || '/';
    const pathWithoutLithuanian = currentPath.replace(/^\/lt(?=\/|$)/, '') || '/';

    if (language === 'lt') {
      return pathWithoutLithuanian === '/' ? '/lt' : `/lt${pathWithoutLithuanian}`;
    }

    return pathWithoutLithuanian;
  };

  const readPreference = () => {
    try {
      return window.localStorage.getItem(preferenceKey);
    } catch (_error) {
      return null;
    }
  };

  const savePreference = (language) => {
    try {
      window.localStorage.setItem(preferenceKey, language);
    } catch (_error) {
      /* Storage can be unavailable in privacy modes; localization still works. */
    }
  };

  const applyLanguage = (language, persistPreference = false) => {
    const normalizedLanguage = String(language || '').toLowerCase();
    if (!availableLanguages.includes(normalizedLanguage)) return;
    if (persistPreference) savePreference(normalizedLanguage);
    if (normalizedLanguage === currentLanguage) return;

    languageInput.value = normalizedLanguage;
    window.location.assign(
      `${localizedPath(normalizedLanguage)}${window.location.search}${window.location.hash}`
    );
  };

  choices.forEach((choice) => {
    choice.addEventListener('click', () => applyLanguage(choice.value, true));
  });

  const footerLanguageForm = document.querySelector('#XMFooterLanguage');
  if (footerLanguageForm) {
    footerLanguageForm.addEventListener('submit', (event) => {
      const submitterLanguage = event.submitter && event.submitter.value;
      if (!submitterLanguage) return;
      event.preventDefault();
      applyLanguage(submitterLanguage, true);
    });
  }

  const savedPreference = readPreference();
  if (savedPreference && availableLanguages.includes(savedPreference.toLowerCase())) {
    if (currentLanguage === 'en' && savedPreference.toLowerCase() === 'lt') {
      applyLanguage('lt', false);
    }
    return;
  }

  const browserLanguage = String(
    (navigator.languages && navigator.languages[0]) || navigator.language || ''
  ).toLowerCase();
  const shopifyCountry = String(window.Shopify && window.Shopify.country || '').toUpperCase();
  const visitorLooksLithuanian = browserLanguage.startsWith('lt') || shopifyCountry === 'LT';

  /*
    Smart default: Lithuanian visitors arriving on the primary EN context move to LT.
    Direct LT URLs are never forced back to EN, and a manual LT/EN choice always wins.
  */
  if (currentLanguage === 'en' && visitorLooksLithuanian) {
    applyLanguage('lt', false);
  }
})();
